<template>
  <div>
    <el-table :data="auditList" height="calc(100vh - 360px)">
      <el-table-column prop="id" label="订单ID"> </el-table-column>
      <el-table-column width="200" label="时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="merchantId" label="商家ID"></el-table-column>
      <el-table-column prop="merchantUserId" label="商家用户ID">
        <template slot-scope="scope">
          <a @click="getUserDetail(scope.row.merchantUserId)">{{
            scope.row.merchantUserId
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户ID">
        <template slot-scope="scope">
          <a @click="getUserDetail(scope.row.userId)">{{ scope.row.userId }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="交易方向">
        <template slot-scope="scope">
          <span v-if="scope.row.direction == 'ASK'">卖单</span>
          <span v-else>买单</span>
        </template>
      </el-table-column>
      <el-table-column prop="coinType" label="币种"> </el-table-column>
      <el-table-column prop="amount" label="数量"> </el-table-column>
      <el-table-column prop="price" label="价格"> </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">
            {{ scope.row.__status.text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="250">
        <template slot-scope="scope">
          <el-tooltip
            content="确认付款"
            v-if="scope.row.status == 3 || scope.row.status == 0"
          >
            <el-button
              type="primary"
              @click="doGetMoney(scope.row.id)"
              icon="el-icon-thumb"
              size="small"
              circle
            >
            </el-button>
          </el-tooltip>
          <el-tooltip
            content="取消订单"
            v-if="scope.row.status > 2 || scope.row.status == 0"
          >
            <el-button
              type="info"
              @click="cancelTheOrder(scope.row.id)"
              icon="el-icon-delete"
              size="small"
              circle
            >
            </el-button>
          </el-tooltip>
          <el-tooltip
            content="确认收款并放币"
            v-if="scope.row.status > 2 || scope.row.status == 0"
          >
            <el-button
              type="warning"
              @click="sendMoney(scope.row.id)"
              icon="el-icon-s-promotion"
              size="small"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="user-withdrawal-records-wrap">
      <el-dialog
        :visible.sync="showUserDialog"
        title="账户余额信息"
        width="1200px"
      >
        <withdraw-records
          v-if="showUserDialog"
          :uid="nowUserId"
        ></withdraw-records>
      </el-dialog>
    </div>
    <div class="pager-wrap" style="text-align: right; margin: 10px 0px">
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="audistCount"
        @pageChanged="handleCurrentChange"
      >
      </pagination>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Pagination from 'components/pagination'
import WithdrawRecords from '../records'

export default {
  name: 'c2call',
  data() {
    return {
      showUserDialog: false,
    }
  },
  computed: {
    ...mapState('c2call', ['auditList', 'audistCount', 'pagination']),
    ...mapState(['userInfo']),
  },
  methods: {
    ...mapActions('c2call', [
      'approve',
      'reject',
      'cancelOrder',
      'gaveMoney',
      'receivedMoney',
    ]),
    showPrompt(content, callback) {
      return this.$confirm(content, '提示', {
        type: 'warning',
      }).then(() => {
        return callback()
          .then(() => {
            this.$message({
              message: '操作成功！',
              type: 'success',
            })
          })
          .finally(() => {
            this.refreshList()
          })
      })
    },
    approveAudit(audit) {
      this.showPrompt('确认通过审核吗？', () => this.approve({ id: audit.id }))
    },
    rejectAudit(audit) {
      this.showPrompt('确认拒绝通过吗？', () => this.reject({ id: audit.id }))
    },
    cancelTheOrder(id) {
      this.showPrompt('确定取消该订单吗？', () => this.cancelOrder({ id: id }))
    },
    doGetMoney(id) {
      this.showPrompt('确定已付款吗？', () => this.gaveMoney({ id: id }))
    },
    sendMoney(id) {
      this.showPrompt('确定收款并放币吗？', () =>
        this.receivedMoney({ id: id })
      )
    },
    refreshList() {
      this.handleCurrentChange({
        page: 1,
      })
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination)
    },
    getUserDetail(uid) {
      this.nowUserId = uid
      this.showUserDialog = true
    },
  },
  components: {
    Pagination,
    WithdrawRecords,
  },
}
</script>

<style lang="less" scoped>
@import url('~styles/variables.less');

.account-link,
.network-link {
  color: @color-primary;
  &:hover {
    text-decoration: underline;
  }
}
</style>
